/**
 * Created by Victor Rojo on 30/8/18.
 */
import { Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'tree-view-menu',
  template: '<tree-view [node]="tree" [selectedNodeId]="selectedNodeId" [nodeSelected]="nodeSelected" [nodeLevel]="nodeLevel" [expandedNodeLevels]="expandedNodeLevels"></tree-view>',
  styleUrls: ['./TreeViewMenu.css']
})
export class TreeViewMenuComponent {
  @Input()
  tree: any;
  @Input()
  selectedNodeId:any;
  nodeLevel: number = 0;
  @Input() expandedNodeLevels: number = 0;
  @Output() public nodeSelected: EventEmitter<any> = new EventEmitter();
}
